import React, { Component } from 'react'
import env from './../../environments/environment'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import './RequestForm.scss'

class RequestForm extends Component {
  regEmailStr = '[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,5}'
  regPhoneStr = '(\\+?\\d{1,3}\\s?)?\\(?\\d{3}\\)?[\\s.\\-]?\\d{3}[\\s.\\-]?\\d{4}'
  // regCurrencyStr = '^\\$?\\s*(?:\\d{1,3}(?:,\\d{3})*|\\d+)(?:\\.\\d{2})?$'
  regCurrencyStr = '^\\$?\\s*(?:\\d{1,3}(?:,\\d{3})*|\\d+)(?:\\.\\d{2})?$'

  constructor(props) {
    super(props)

    this.regPhone = new RegExp(this.regPhoneStr)
    this.regEmail = new RegExp(this.regEmailStr)
    this.regCurrency = new RegExp(this.regCurrencyStr)

    this.state = {
      requestSubmit: false,
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      state: '',
      notes: '',

      // What is your primary market?
      primary_market: '', // ACA, Alternative U65 or the Senior Market?
      // What is your taxable earnings?
      taxable_earnings: '', // Greater than $500K, Greater than $1MM, Geater than $2MM
      // Can you quickly provide 2-3 years of P&Ls?
      can_provide_pl: '',
      // How many writing agents do you have?
      num_writing_agents: '',
      // How many employees do you have?
      num_employees: '',
      // Are you willing to stay on for at least 3 years?
      stay_on: '',
    }
    this.onChange = this.onChange.bind(this)
    this.CREATEQuote_API = this.CREATEQuote_API.bind(this)
  }

  validate() {
    const {
      firstname,
      lastname,
      email,
      mobile,
      state,
      primary_market,
      taxable_earnings,
      can_provide_pl,
      num_writing_agents,
      num_employees,
      stay_on,
    } = this.state

    if (
      !(firstname && firstname.trim()) ||
      !(lastname && lastname.trim()) ||
      !(email && email.trim()) ||
      !this.regEmail.test(email) ||
      !(mobile && mobile.trim()) ||
      !this.regPhone.test(mobile) ||
      !(state && state.trim()) ||
      !primary_market ||
      !taxable_earnings ||
      !this.regCurrency.test(taxable_earnings) ||
      !can_provide_pl ||
      (!num_writing_agents && parseInt(num_writing_agents) !== 0) ||
      (!num_employees && parseInt(num_employees) !== 0) ||
      !stay_on
    ) {
      return false
    }
    return true
  }

  async CREATEQuote_API(event) {
    event.preventDefault()

    let targetDom = event.target
    const {
      firstname,
      lastname,
      email,
      mobile,
      state,
      notes,
      primary_market,
      taxable_earnings,
      can_provide_pl,
      num_writing_agents,
      num_employees,
      stay_on,
      requestSubmit,
    } = this.state
    if (requestSubmit) return
    event.target.className += ' was-validated'

    const isValid = this.validate()
    if (!isValid) {
      toast.error('Invalid form data', { position: toast.POSITION.TOP_RIGHT })
      return
    }
    const data = {
      firstname,
      lastname,
      email,
      mobile,
      state,
      notes,
      primary_market,
      taxable_earnings,
      can_provide_pl,
      num_writing_agents,
      num_employees,
      stay_on,
      req_url: window.location.href,
      ref_url: document.referrer,
    }

    let form_data = new FormData()

    for (let key in data) form_data.append(key, data[key])

    try {
      await AdminApi.createMAndALeadCapture(form_data).then(response => {
        this.setState({ requestSubmit: false })
        if (typeof this.props?.onSuccess === 'function') this.props.onSuccess({ response })
        if (response.status === 200) {
          this.setState({
            firstname: '',
            lastname: '',
            email: '',
            mobile: '',
            state: '',
            notes: '',
            primary_market: '',
            taxable_earnings: '',
            can_provide_pl: '',
            num_writing_agents: '',
            num_employees: '',
            stay_on: '',
          })
          toast.success('Quote request sent!', {
            position: toast.POSITION.TOP_RIGHT,
          })
          targetDom.className = targetDom.className.replace(/ was-validated/g, '')
          setInterval(() => {
            if (typeof this.props?.onSuccess === 'function') this.props.onSuccess()
          }, 2500)
        }
      })
    } catch (error) {
      this.setState({ requestSubmit: false })
      toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      targetDom.className = targetDom.className.replace(/ was-validated/g, '')
    }
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  render() {
    toast.configure()

    const {
      firstname,
      lastname,
      email,
      mobile,
      state,
      notes,
      primary_market,
      taxable_earnings,
      can_provide_pl,
      num_writing_agents,
      num_employees,
      stay_on,
      requestSubmit,
    } = this.state

    return (
      <div
        style={{
          backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fimg.entrepreneur.jpg?alt=media)`,
          backgroundPositionY: 'center',
        }}
        className='RequestFormComponent section-60 section-sm-90 bg-athens-gray bg-image bg-image-sm-hide'
      >
        <div className='shell'>
          <div className='range range-sm-right'>
            <div className='cell-sm-8 cell-md-7 cell-lg-7'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col'>
                    <div className='range'>
                      <div className='cell-xs-12 text-center'>
                        <h2>
                          <span className='sub-head-small'>Build your freedom-focused future now!</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <form
                      data-form-output='form-output-global'
                      data-form-type='contact'
                      onSubmit={event => this.CREATEQuote_API(event)}
                      noValidate
                      className='range range-xs-center range-sm-left rd-mailform'
                    >
                      {/*First Name*/}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='firstname'
                            type='text'
                            name='firstname'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={firstname}
                            onChange={this.onChange}
                            placeholder={'First Name'}
                            required
                          />
                          <div className='invalid-feedback'>Please provide first name.</div>
                        </div>
                      </div>

                      {/*Last Name*/}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='lastname'
                            type='text'
                            name='lastname'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={lastname}
                            onChange={this.onChange}
                            placeholder={'Last Name'}
                            required
                          />
                          <div className='invalid-feedback'>Please provide last name.</div>
                        </div>
                      </div>

                      {/*Email*/}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='email'
                            type='text'
                            name='email'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={email}
                            autoComplete='off'
                            onChange={this.onChange}
                            placeholder={'E-mail'}
                            pattern={this.regEmailStr}
                            required
                          />
                          <div className='invalid-feedback'>Please complete or correct the email address.</div>
                        </div>
                      </div>

                      {/*Phone*/}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='phone'
                            type='text'
                            name='mobile'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={mobile}
                            onChange={this.onChange}
                            placeholder={'Phone'}
                            required
                            pattern={this.regPhoneStr}
                          />
                          <div className='invalid-feedback'>Please complete or correct the phone number.</div>
                        </div>
                      </div>
                      <hr />
                      <div className='cell-sm-6 offset-top-20'></div>
                      <div className='cell-sm-6 offset-top-20'></div>

                      {/* State */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='state'
                            type='text'
                            name='state'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={state}
                            onChange={this.onChange}
                            placeholder={'State'}
                            required
                          />
                          <div className='invalid-feedback'>Please provide state.</div>
                        </div>
                      </div>
                      <div className='cell-sm-6 offset-top-20'></div>

                      {/*Primary Market*/}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <select
                            id='primary_market'
                            name='primary_market'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            onChange={this.onChange}
                            required
                            value={primary_market}
                          >
                            <option value='' disabled>
                              Select Primary Market
                            </option>
                            <option value='ACA'>ACA</option>
                            <option value='Alternative U65'>Alternative U65</option>
                            <option value='Senior'>Senior</option>
                          </select>
                          <div className='invalid-feedback'>Please select primary market.</div>
                        </div>
                      </div>

                      {/* Can you provide P&L */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <select
                            id='can_provide_pl'
                            name='can_provide_pl'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            onChange={this.onChange}
                            required
                            value={can_provide_pl}
                          >
                            <option value='' disabled>
                              Have 2-3 years of P&Ls?
                            </option>
                            <option value='Yes'>Yes</option>
                            <option value='No'>No</option>
                          </select>
                          <div className='invalid-feedback'>Please indicate if you have 2-3 years of P&Ls ready.</div>
                        </div>
                      </div>

                      {/* Taxable Earnings */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='taxable_earnings'
                            type='text'
                            name='taxable_earnings'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={taxable_earnings}
                            onChange={this.onChange}
                            placeholder={'Taxable Earnings'}
                            required
                            pattern={this.regCurrencyStr}
                          />
                          <div className='invalid-feedback'>Please complete or correct your taxable earnings.</div>
                        </div>
                      </div>

                      {/* How many writing agents */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='num_writing_agents'
                            type='number'
                            name='num_writing_agents'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={num_writing_agents}
                            onChange={this.onChange}
                            placeholder={'Number of Writing Agents'}
                            required
                          />
                          <div className='invalid-feedback'>Please complete or correct number of writing agents.</div>
                        </div>
                      </div>

                      {/* How many Employees */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <input
                            id='num_employees'
                            type='number'
                            name='num_employees'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={num_employees}
                            onChange={this.onChange}
                            placeholder={'Number of Employees'}
                            required
                          />
                          <div className='invalid-feedback'>Please complete or correct number of employees.</div>
                        </div>
                      </div>

                      {/* Stay On for 3 years? */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <select
                            id='stay_on'
                            name='stay_on'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            onChange={this.onChange}
                            required
                            value={stay_on}
                          >
                            <option value='' disabled>
                              Willing to stay on for 3 years?
                            </option>
                            <option value='Yes'>Yes</option>
                            <option value='No'>No</option>
                          </select>
                          <div className='invalid-feedback'>
                            Please indicate if you're willing to stay on for 3 years.
                          </div>
                        </div>
                      </div>

                      <div className='cell-sm-6 offset-top-20'></div>
                      <div className='cell-sm-6 offset-top-20'></div>

                      {/* Comments Textarea */}
                      <div className='cell-sm-6 offset-top-20'>
                        <div className='form-group form-group-outside'>
                          <textarea
                            id='notes'
                            name='notes'
                            className='form-control bg-whisper-lighten border-radius-0 mb-2'
                            value={notes}
                            rows='3'
                            onChange={this.onChange}
                            placeholder={'Comments'}
                            style={{ height: 'auto' }}
                          />
                          <div className='invalid-feedback'>Please provide comments.</div>
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className='cell-sm-6 offset-top-20'>
                        <button
                          type='submit'
                          className='btn btn-icon btn-icon-right btn-primary-contrast btn-custom btn-block'
                          style={{ marginTop: '15px' }}
                        >
                          <span>{requestSubmit ? 'Submitting...' : 'Submit'}</span>
                          <span className='icon icon-xs-smaller fa-angle-right'></span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RequestForm
